import {RubyPlayGameClientWrapper} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';

export class KoalaGameClientWrapper extends RubyPlayGameClientWrapper {
    public static NAME = 'koala';
}